import { useLang, route } from "../i18n";
import { useCompany } from "./SiteContext";
import { ButtonPrimary } from "./Buttons";
import { MaskedLines, Reveal } from "./Reveal";
import { AviahWatermark } from "./AviahMark";
import { track } from "../lib/track";

// The closing argument — carbon, champagne, one conversation.
const FinalCta = () => {
  const { lang, t } = useLang();
  const company = useCompany();
  const f = t.home.final;

  return (
    <section className="grain relative overflow-hidden bg-[#171717]" data-testid="final-cta">
      <AviahWatermark className="absolute -left-24 top-1/2 h-[28rem] w-[28rem] -translate-y-1/2 opacity-[0.05]" />
      <div className="relative mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-36">
        <div className="max-w-3xl">
          <MaskedLines
            as="h2"
            lines={[f.title]}
            className="text-3xl font-light leading-[1.12] tracking-tight text-[#F4F0E8] sm:text-4xl lg:text-5xl"
          />
          <Reveal delay={0.2}>
            <p className="mt-8 max-w-xl text-sm leading-relaxed text-[#F4F0E8]/65 sm:text-base">{f.copy}</p>
          </Reveal>
          <Reveal delay={0.3}>
            <div className="mt-10 flex flex-wrap items-center gap-6">
              <ButtonPrimary to={route(lang, "contact")} testid="final-cta-button" event="book_consultation_click">
                {f.cta}
              </ButtonPrimary>
              <a
                href={company.phoneHref}
                data-testid="final-cta-phone"
                onClick={() => track("phone_click", { location: "final_cta" })}
                className="text-sm text-[#F4F0E8]/75 transition-colors hover:text-[#C6A46A]"
              >
                {f.or} <span className="text-[#C6A46A]">{company.phone}</span>
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default FinalCta;
